import { RouteObject } from '@rocketlane/rocket-router';
import { DocumentAgentPreviewPage } from 'components/organisms/pages-template/document-agent-page/preview';
import { DocumentAgentTestPage } from 'components/organisms/pages-template/document-agent-page/test';
import { AgentBuilderRemote } from 'components/pages/agent-builder-remote';
import { SecureRoute } from './secure-route';

export const agentBuilderRoutes: RouteObject[] = [
  {
    path: '/agent-builder',
    children: [
      { index: true, element: <AgentBuilderRemote /> },
      {
        path: 'documentation/:documentationAgentId/test',
        element: (
          <SecureRoute>
            <DocumentAgentTestPage />
          </SecureRoute>
        ),
      },
      {
        path: 'documentation/:documentationAgentId/preview',
        element: (
          <SecureRoute>
            <DocumentAgentPreviewPage />
          </SecureRoute>
        ),
      },
      { path: '*', element: <AgentBuilderRemote /> }, // Catch all other sub-routes
    ],
  },
];
